// @generated by protoc-gen-es v2.12.0 with parameter "target=ts"
// @generated from file vision/generations/v1/vision_generation.proto (package protos.vision.generations.v1, syntax proto3)
/* eslint-disable */

import type { GenEnum, GenFile, GenMessage } from "@bufbuild/protobuf/codegenv2";
import { enumDesc, fileDesc, messageDesc } from "@bufbuild/protobuf/codegenv2";
import type { Timestamp } from "@bufbuild/protobuf/wkt";
import { file_google_protobuf_timestamp } from "@bufbuild/protobuf/wkt";
import type { GradingSettings } from "../../grading/v1/grading_settings_pb";
import { file_vision_grading_v1_grading_settings } from "../../grading/v1/grading_settings_pb";
import type { GenerationCrop } from "./generation_crop_pb";
import { file_vision_generations_v1_generation_crop } from "./generation_crop_pb";
import type { MaskRegion } from "./mask_region_pb";
import { file_vision_generations_v1_mask_region } from "./mask_region_pb";
import type { Message } from "@bufbuild/protobuf";

/**
 * Describes the file vision/generations/v1/vision_generation.proto.
 */
export const file_vision_generations_v1_vision_generation: GenFile = /*@__PURE__*/
  fileDesc("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", [file_google_protobuf_timestamp, file_vision_grading_v1_grading_settings, file_vision_generations_v1_generation_crop, file_vision_generations_v1_mask_region]);

/**
 * @generated from message protos.vision.generations.v1.VisionGenerationLike
 */
export type VisionGenerationLike = Message<"protos.vision.generations.v1.VisionGenerationLike"> & {
  /**
   * @generated from field: string account_id = 1;
   */
  accountId: string;

  /**
   * @generated from field: string name = 2;
   */
  name: string;

  /**
   * @generated from field: string pfp_url = 3;
   */
  pfpUrl: string;

  /**
   * @generated from field: google.protobuf.Timestamp created_at = 4;
   */
  createdAt?: Timestamp | undefined;
};

/**
 * Describes the message protos.vision.generations.v1.VisionGenerationLike.
 * Use `create(VisionGenerationLikeSchema)` to create a new message.
 */
export const VisionGenerationLikeSchema: GenMessage<VisionGenerationLike> = /*@__PURE__*/
  messageDesc(file_vision_generations_v1_vision_generation, 0);

/**
 * @generated from message protos.vision.generations.v1.VisionGeneration
 */
export type VisionGeneration = Message<"protos.vision.generations.v1.VisionGeneration"> & {
  /**
   * @generated from field: string generation_id = 1;
   */
  generationId: string;

  /**
   * @generated from field: string image_id = 2;
   */
  imageId: string;

  /**
   * @generated from field: string project_id = 3;
   */
  projectId: string;

  /**
   * @generated from field: protos.vision.generations.v1.GenerationStatus status = 4;
   */
  status: GenerationStatus;

  /**
   * @generated from field: string generated_url = 5;
   */
  generatedUrl: string;

  /**
   * @generated from field: string thumbnail_url = 6;
   */
  thumbnailUrl: string;

  /**
   * @generated from field: string generated_by_account_id = 7;
   */
  generatedByAccountId: string;

  /**
   * @generated from field: string generated_by_name = 21;
   */
  generatedByName: string;

  /**
   * @generated from field: string generated_by_pfp_url = 22;
   */
  generatedByPfpUrl: string;

  /**
   * @generated from field: google.protobuf.Timestamp created_at = 8;
   */
  createdAt?: Timestamp | undefined;

  /**
   * @generated from field: google.protobuf.Timestamp updated_at = 9;
   */
  updatedAt?: Timestamp | undefined;

  /**
   * @generated from field: int32 generation_time_ms = 10;
   */
  generationTimeMs: number;

  /**
   * @generated from field: string error_message = 11;
   */
  errorMessage: string;

  /**
   * @generated from field: string graded_url = 12;
   */
  gradedUrl: string;

  /**
   * @generated from field: string graded_thumbnail_url = 13;
   */
  gradedThumbnailUrl: string;

  /**
   * @generated from field: protos.vision.grading.v1.GradingSettings grading_settings = 14;
   */
  gradingSettings?: GradingSettings | undefined;

  /**
   * @generated from field: string display_url = 15;
   */
  displayUrl: string;

  /**
   * @generated from field: string color_reference_url = 16;
   */
  colorReferenceUrl: string;

  /**
   * @generated from field: repeated string additional_reference_urls = 17;
   */
  additionalReferenceUrls: string[];

  /**
   * @generated from oneof protos.vision.generations.v1.VisionGeneration.workflow_details
   */
  workflowDetails: {
    /**
     * @generated from field: protos.vision.generations.v1.VisionGeneration.StandardImageDetails standard_image = 18;
     */
    value: VisionGeneration_StandardImageDetails;
    case: "standardImage";
  } | {
    /**
     * @generated from field: protos.vision.generations.v1.VisionGeneration.RefineDetails refine = 19;
     */
    value: VisionGeneration_RefineDetails;
    case: "refine";
  } | {
    /**
     * @generated from field: protos.vision.generations.v1.VisionGeneration.UpscaleDetails upscale = 23;
     */
    value: VisionGeneration_UpscaleDetails;
    case: "upscale";
  } | {
    /**
     * @generated from field: protos.vision.generations.v1.VisionGeneration.RecreateDetails recreate = 25;
     */
    value: VisionGeneration_RecreateDetails;
    case: "recreate";
  } | {
    /**
     * @generated from field: protos.vision.generations.v1.VisionGeneration.ImportSceneLookDetails import_scene_look = 26;
     */
    value: VisionGeneration_ImportSceneLookDetails;
    case: "importSceneLook";
  } | {
    /**
     * @generated from field: protos.vision.generations.v1.VisionGeneration.SetDressingDetails set_dressing = 27;
     */
    value: VisionGeneration_SetDressingDetails;
    case: "setDressing";
  } | {
    /**
     * @generated from field: protos.vision.generations.v1.VisionGeneration.MaskInpaintDetails mask_inpaint = 28;
     */
    value: VisionGeneration_MaskInpaintDetails;
    case: "maskInpaint";
  } | {
    /**
     * @generated from field: protos.vision.generations.v1.VisionGeneration.VisionBoardTextToImageDetails vision_board_text_to_image = 30;
     */
    value: VisionGeneration_VisionBoardTextToImageDetails;
    case: "visionBoardTextToImage";
  } | { case: undefined; value?: undefined };

  /**
   * @generated from field: repeated protos.vision.generations.v1.VisionGenerationLike likes = 20;
   */
  likes: VisionGenerationLike[];

  /**
   * @generated from field: protos.vision.generations.v1.GenerationCrop crop = 24;
   */
  crop?: GenerationCrop | undefined;

  /**
   * @generated from field: repeated protos.vision.generations.v1.MaskRegion mask_regions = 29;
   */
  maskRegions: MaskRegion[];

  /**
   * @generated from field: repeated string additional_reference_asset_ids = 31;
   */
  additionalReferenceAssetIds: string[];
};

/**
 * Describes the message protos.vision.generations.v1.VisionGeneration.
 * Use `create(VisionGenerationSchema)` to create a new message.
 */
export const VisionGenerationSchema: GenMessage<VisionGeneration> = /*@__PURE__*/
  messageDesc(file_vision_generations_v1_vision_generation, 1);

/**
 * @generated from message protos.vision.generations.v1.VisionGeneration.StandardImageDetails
 */
export type VisionGeneration_StandardImageDetails = Message<"protos.vision.generations.v1.VisionGeneration.StandardImageDetails"> & {
  /**
   * @generated from field: string prompt = 1;
   */
  prompt: string;

  /**
   * @generated from field: string user_prompt = 2;
   */
  userPrompt: string;

  /**
   * @generated from field: string aspect_ratio = 3;
   */
  aspectRatio: string;

  /**
   * @generated from field: bool use_thinking = 4;
   */
  useThinking: boolean;
};

/**
 * Describes the message protos.vision.generations.v1.VisionGeneration.StandardImageDetails.
 * Use `create(VisionGeneration_StandardImageDetailsSchema)` to create a new message.
 */
export const VisionGeneration_StandardImageDetailsSchema: GenMessage<VisionGeneration_StandardImageDetails> = /*@__PURE__*/
  messageDesc(file_vision_generations_v1_vision_generation, 1, 0);

/**
 * @generated from message protos.vision.generations.v1.VisionGeneration.RefineDetails
 */
export type VisionGeneration_RefineDetails = Message<"protos.vision.generations.v1.VisionGeneration.RefineDetails"> & {
  /**
   * @generated from field: string prompt = 1;
   */
  prompt: string;

  /**
   * @generated from field: string user_prompt = 2;
   */
  userPrompt: string;

  /**
   * @generated from field: string aspect_ratio = 3;
   */
  aspectRatio: string;

  /**
   * @generated from field: string parent_generation_id = 4;
   */
  parentGenerationId: string;

  /**
   * @generated from field: bool use_thinking = 5;
   */
  useThinking: boolean;
};

/**
 * Describes the message protos.vision.generations.v1.VisionGeneration.RefineDetails.
 * Use `create(VisionGeneration_RefineDetailsSchema)` to create a new message.
 */
export const VisionGeneration_RefineDetailsSchema: GenMessage<VisionGeneration_RefineDetails> = /*@__PURE__*/
  messageDesc(file_vision_generations_v1_vision_generation, 1, 1);

/**
 * @generated from message protos.vision.generations.v1.VisionGeneration.UpscaleDetails
 */
export type VisionGeneration_UpscaleDetails = Message<"protos.vision.generations.v1.VisionGeneration.UpscaleDetails"> & {
  /**
   * @generated from field: string user_prompt = 1;
   */
  userPrompt: string;

  /**
   * @generated from field: string aspect_ratio = 2;
   */
  aspectRatio: string;

  /**
   * @generated from field: string parent_generation_id = 3;
   */
  parentGenerationId: string;
};

/**
 * Describes the message protos.vision.generations.v1.VisionGeneration.UpscaleDetails.
 * Use `create(VisionGeneration_UpscaleDetailsSchema)` to create a new message.
 */
export const VisionGeneration_UpscaleDetailsSchema: GenMessage<VisionGeneration_UpscaleDetails> = /*@__PURE__*/
  messageDesc(file_vision_generations_v1_vision_generation, 1, 2);

/**
 * @generated from message protos.vision.generations.v1.VisionGeneration.RecreateDetails
 */
export type VisionGeneration_RecreateDetails = Message<"protos.vision.generations.v1.VisionGeneration.RecreateDetails"> & {
  /**
   * @generated from field: string prompt = 1;
   */
  prompt: string;

  /**
   * @generated from field: string user_prompt = 2;
   */
  userPrompt: string;

  /**
   * @generated from field: string aspect_ratio = 3;
   */
  aspectRatio: string;

  /**
   * @generated from field: string parent_generation_id = 4;
   */
  parentGenerationId: string;
};

/**
 * Describes the message protos.vision.generations.v1.VisionGeneration.RecreateDetails.
 * Use `create(VisionGeneration_RecreateDetailsSchema)` to create a new message.
 */
export const VisionGeneration_RecreateDetailsSchema: GenMessage<VisionGeneration_RecreateDetails> = /*@__PURE__*/
  messageDesc(file_vision_generations_v1_vision_generation, 1, 3);

/**
 * @generated from message protos.vision.generations.v1.VisionGeneration.ImportSceneLookDetails
 */
export type VisionGeneration_ImportSceneLookDetails = Message<"protos.vision.generations.v1.VisionGeneration.ImportSceneLookDetails"> & {
  /**
   * @generated from field: string prompt = 1;
   */
  prompt: string;

  /**
   * @generated from field: string user_prompt = 2;
   */
  userPrompt: string;

  /**
   * @generated from field: string aspect_ratio = 3;
   */
  aspectRatio: string;

  /**
   * @generated from field: string source_image_id = 4;
   */
  sourceImageId: string;

  /**
   * @generated from field: string source_generation_id = 5;
   */
  sourceGenerationId: string;

  /**
   * @generated from field: bool clear_scene = 6;
   */
  clearScene: boolean;
};

/**
 * Describes the message protos.vision.generations.v1.VisionGeneration.ImportSceneLookDetails.
 * Use `create(VisionGeneration_ImportSceneLookDetailsSchema)` to create a new message.
 */
export const VisionGeneration_ImportSceneLookDetailsSchema: GenMessage<VisionGeneration_ImportSceneLookDetails> = /*@__PURE__*/
  messageDesc(file_vision_generations_v1_vision_generation, 1, 4);

/**
 * @generated from message protos.vision.generations.v1.VisionGeneration.SetDressingDetails
 */
export type VisionGeneration_SetDressingDetails = Message<"protos.vision.generations.v1.VisionGeneration.SetDressingDetails"> & {
  /**
   * @generated from field: string prompt = 1;
   */
  prompt: string;

  /**
   * @generated from field: string user_prompt = 2;
   */
  userPrompt: string;

  /**
   * @generated from field: string aspect_ratio = 3;
   */
  aspectRatio: string;

  /**
   * @generated from field: string source_generation_id = 4;
   */
  sourceGenerationId: string;

  /**
   * @generated from field: bool clear_scene = 5;
   */
  clearScene: boolean;
};

/**
 * Describes the message protos.vision.generations.v1.VisionGeneration.SetDressingDetails.
 * Use `create(VisionGeneration_SetDressingDetailsSchema)` to create a new message.
 */
export const VisionGeneration_SetDressingDetailsSchema: GenMessage<VisionGeneration_SetDressingDetails> = /*@__PURE__*/
  messageDesc(file_vision_generations_v1_vision_generation, 1, 5);

/**
 * @generated from message protos.vision.generations.v1.VisionGeneration.MaskInpaintDetails
 */
export type VisionGeneration_MaskInpaintDetails = Message<"protos.vision.generations.v1.VisionGeneration.MaskInpaintDetails"> & {
  /**
   * @generated from field: string prompt = 1;
   */
  prompt: string;

  /**
   * @generated from field: string user_prompt = 2;
   */
  userPrompt: string;

  /**
   * @generated from field: string aspect_ratio = 3;
   */
  aspectRatio: string;

  /**
   * @generated from field: string parent_generation_id = 4;
   */
  parentGenerationId: string;

  /**
   * @generated from field: repeated protos.vision.generations.v1.MaskRegion regions = 5;
   */
  regions: MaskRegion[];
};

/**
 * Describes the message protos.vision.generations.v1.VisionGeneration.MaskInpaintDetails.
 * Use `create(VisionGeneration_MaskInpaintDetailsSchema)` to create a new message.
 */
export const VisionGeneration_MaskInpaintDetailsSchema: GenMessage<VisionGeneration_MaskInpaintDetails> = /*@__PURE__*/
  messageDesc(file_vision_generations_v1_vision_generation, 1, 6);

/**
 * @generated from message protos.vision.generations.v1.VisionGeneration.VisionBoardTextToImageDetails
 */
export type VisionGeneration_VisionBoardTextToImageDetails = Message<"protos.vision.generations.v1.VisionGeneration.VisionBoardTextToImageDetails"> & {
  /**
   * @generated from field: string prompt = 1;
   */
  prompt: string;

  /**
   * @generated from field: string user_prompt = 2;
   */
  userPrompt: string;

  /**
   * @generated from field: string aspect_ratio = 3;
   */
  aspectRatio: string;

  /**
   * @generated from field: bool use_thinking = 4;
   */
  useThinking: boolean;

  /**
   * @generated from field: string user_rules = 5;
   */
  userRules: string;
};

/**
 * Describes the message protos.vision.generations.v1.VisionGeneration.VisionBoardTextToImageDetails.
 * Use `create(VisionGeneration_VisionBoardTextToImageDetailsSchema)` to create a new message.
 */
export const VisionGeneration_VisionBoardTextToImageDetailsSchema: GenMessage<VisionGeneration_VisionBoardTextToImageDetails> = /*@__PURE__*/
  messageDesc(file_vision_generations_v1_vision_generation, 1, 7);

/**
 * @generated from enum protos.vision.generations.v1.GenerationStatus
 */
export enum GenerationStatus {
  /**
   * @generated from enum value: GENERATION_STATUS_UNKNOWN = 0;
   */
  UNKNOWN = 0,

  /**
   * @generated from enum value: GENERATION_STATUS_PENDING = 1;
   */
  PENDING = 1,

  /**
   * @generated from enum value: GENERATION_STATUS_COMPLETE = 2;
   */
  COMPLETE = 2,

  /**
   * @generated from enum value: GENERATION_STATUS_FAILED = 3;
   */
  FAILED = 3,
}

/**
 * Describes the enum protos.vision.generations.v1.GenerationStatus.
 */
export const GenerationStatusSchema: GenEnum<GenerationStatus> = /*@__PURE__*/
  enumDesc(file_vision_generations_v1_vision_generation, 0);

